import React from 'react';
const TrilogyContext = React.createContext({
    styled: false,
    setStyled: () => undefined,
});
const useTrilogyContext = () => {
    const context = React.useContext(TrilogyContext);
    if (context === undefined) {
        throw new Error('useTrilogyContext must be used within a TrilogyProvider');
    }
    return context;
};
export { TrilogyContext, useTrilogyContext };
//# sourceMappingURL=index.js.map